/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BidvTransferDestWhitelistDeleteEntity } from '../models/BidvTransferDestWhitelistDeleteEntity';
import type { BidvTransferDestWhitelistItemEntity } from '../models/BidvTransferDestWhitelistItemEntity';
import type { BidvTransferDestWhitelistListEntity } from '../models/BidvTransferDestWhitelistListEntity';
import type { CreateBidvTransferDestWhitelistDto } from '../models/CreateBidvTransferDestWhitelistDto';
import type { UpdateBidvTransferDestWhitelistDto } from '../models/UpdateBidvTransferDestWhitelistDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BidvTransferDestWhitelistService {
  /**
   * Lấy danh sách whitelist tài khoản đích chuyển tiền BIDV
   * Lấy danh sách tài khoản đích theo phạm vi company.
   * @param companyId Lọc theo công ty (chỉ dành cho admin/spadmin)
   * @param search Tìm kiếm: khớp chính xác số tài khoản hoặc tìm kiếm tên (hỗ trợ wildcard *)
   * @param transferMethod Lọc theo phương thức chuyển tiền
   * @param page
   * @param limit
   * @returns BidvTransferDestWhitelistListEntity
   * @throws ApiError
   */
  public static bidvTransferDestWhitelistControllerList(
    companyId?: string,
    search?: string,
    transferMethod?: 'I' | 'O' | 'F',
    page: string = '1',
    limit: string = '20',
  ): CancelablePromise<BidvTransferDestWhitelistListEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bidv/transfer-dest-whitelist',
      query: {
        companyId: companyId,
        search: search,
        transferMethod: transferMethod,
        page: page,
        limit: limit,
      },
    });
  }

  /**
   * Thêm tài khoản đích vào whitelist chuyển tiền BIDV
   * Thêm một tài khoản đích vào whitelist.
   * @param requestBody
   * @returns BidvTransferDestWhitelistItemEntity
   * @throws ApiError
   */
  public static bidvTransferDestWhitelistControllerCreate(
    requestBody: CreateBidvTransferDestWhitelistDto,
  ): CancelablePromise<BidvTransferDestWhitelistItemEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv/transfer-dest-whitelist',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Cập nhật whitelist tài khoản đích chuyển tiền BIDV
   * Cập nhật thông tin tài khoản đích trong whitelist.
   * @param id UUID of the whitelist entry
   * @param requestBody
   * @returns BidvTransferDestWhitelistItemEntity
   * @throws ApiError
   */
  public static bidvTransferDestWhitelistControllerUpdate(
    id: string,
    requestBody: UpdateBidvTransferDestWhitelistDto,
  ): CancelablePromise<BidvTransferDestWhitelistItemEntity> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/bidv/transfer-dest-whitelist/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Xóa tài khoản đích khỏi whitelist chuyển tiền BIDV
   * Xóa tài khoản đích khỏi whitelist.
   * @param id UUID of the whitelist entry
   * @returns BidvTransferDestWhitelistDeleteEntity
   * @throws ApiError
   */
  public static bidvTransferDestWhitelistControllerDelete(
    id: string,
  ): CancelablePromise<BidvTransferDestWhitelistDeleteEntity> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/bidv/transfer-dest-whitelist/{id}',
      path: {
        id: id,
      },
    });
  }
}
